import type { IOrganismPromoCard } from '@belong/types';
import { Entry } from 'contentful';
import { FLink } from '../elements';
import { FMoleculeCallout } from '../molecules';
import { FRichText } from '../richText.factory';

export const FOrganismPromoCard = (data: Entry<any>): Omit<IOrganismPromoCard, 'dictionary'> => {
  const { colour, callout, content, button } = data.fields;

  return {
    colour,
    callout: FMoleculeCallout(callout),
    content: content && FRichText(content),
    button: button && FLink(button)
  };
};
